import { render, staticRenderFns } from "./editorPopover.vue?vue&type=template&id=f18b46ea&"
import script from "./editorPopover.vue?vue&type=script&lang=js&"
export * from "./editorPopover.vue?vue&type=script&lang=js&"
import style0 from "./editorPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports